import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { InlineInputGroup } from 'barnyard/components';
import { Row, Col } from 'barnyard/layouts';
import { daysOfTheWeek } from '~/app/common/constants/utils';
import DayOfWeekSelect from '~/app/corporate/core/components/DayOfWeekSelect';
import RuleForm from '../inputs/RuleForm';
import InlineSupplierSelect from '../inputs/InlineSupplierSelect';
import InlineRegionSelect from '../inputs/InlineRegionSelect';


class DelayPurchaseGuidance extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onReset = this.onReset.bind(this);
    const { initialValues } = props;
    this.initialState = {
      start: initialValues.start || daysOfTheWeek.SUNDAY.value,
      end: initialValues.end || daysOfTheWeek.SATURDAY.value,
      reset: initialValues.reset || [daysOfTheWeek.MONDAY.value],
      supplier: initialValues.supplier || 1,
      regions: initialValues.regions && initialValues.regions.length > 0 ? initialValues.regions : [0]
    };
    this.state = this.initialState;
  }

  onSubmit(event) {
    event.preventDefault();
    const value = _.omit(this.state, 'regions');
    this.props.onSubmit({
      kind: 'delay_purchase',
      regions: _.filter(this.state.regions),
      value: {
        ...value,
        supplier: parseInt(value.supplier, 10),
      }
    });
  }

  onReset() {
    this.setState(this.initialState);
  }

  render() {
    const { regions } = this.state;
    const { form, type, ...other } = this.props;

    return (
      <RuleForm
        {...other}
        onSubmit={this.onSubmit}
        onReset={this.onReset}
        isSubmitting={form.is_submitting}
      >
        <InlineRegionSelect
          onChange={val => this.setState({ regions: val })}
          value={regions}
        />
        <InlineSupplierSelect
          value={this.state.supplier}
          onChange={supplier => this.setState({ supplier })}
          include_all={false}
          include_any={false}
        />
        <InlineInputGroup label='Date Range' description='Days to show this guidance'>
          <Row align='middle'>
            <Col>

              <DayOfWeekSelect
                value={this.state.start}
                onChange={value => this.setState({ start: value })}
                mode='single'
              />
            </Col>
            <Col span={0}>
              <div className='u-paddingLeft20 u-paddingRight20'>
                -
              </div>
            </Col>
            <Col>
              <DayOfWeekSelect
                value={this.state.end}
                onChange={value => this.setState({ end: value })}
                mode='single'
              />
            </Col>

          </Row>
        </InlineInputGroup>
        <InlineInputGroup
          label='Day of Orders'
          description='Day(s) of the week that clinics should place orders'
          InputComponent={DayOfWeekSelect}
          value={this.state.reset}
          mode='multiple'
          onChange={value => this.setState({ reset: value })}
        />
      </RuleForm>
    );
  }
}

DelayPurchaseGuidance.defaultProps = {
  type: 'add',
  initialValues: {}
};

DelayPurchaseGuidance.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  type: PropTypes.string,
  initialValues: PropTypes.object,
};

export default DelayPurchaseGuidance;
